<template>
  <div>
    <TeCoursePythonCover
      :begins-at="beginsAt"
      :closes-at="closesAt"
    />
    <TeCommonPagenav class="hidden md:block">
      <template #courseicon>
        <FontAwesomeIcon
          :icon="faPython"
          class="fa-fw mr-2 size-5"
        />
      </template>
      <template #coursename>
        Python<span class="hidden md:inline">コース</span>
      </template>
    </TeCommonPagenav>

    <!-- 無料相談割引コード -->
    <TeCommonBannerTimeLimitCpnCode
      v-if="BannerNameForShowing === 'campaign'"
      :entry-campaign="entryCampaign"
    />

    <TeCommonBannerSettlement
      v-if="BannerNameForShowing === 'settlement'"
      :entry-settlement-time-limit="entrySettlementTimeLimit"
      :entry-payment-url="entryPaymentUrl"
    />
    <TeCommonBannerTimelimit
      v-if="BannerNameForShowing === 'discount'"
      :entry-discount-time-limit="entryDiscountTimeLimit"
    />
    <TeCommonBannerCampaign
      :course-name-path="courseNamePath"
      :current-promotion="currentPromotion"
    />
    <TeCourseAbout>
      <template #title>
        Pythonコースについて
      </template>
      <template #discription>
        <p class="co-display-10 mb-3 inline text-co-gray-500 md:block">
          1人では続かない方のためのパーソナルメンターがつく学習プログラム。
        </p>
        <p class="co-display-10 mb-3 inline text-co-gray-500 md:block">
          週2回マンツーマンでのメンタリング、毎日15〜23時のチャット・レビューサポートで
        </p>
        <p class="co-display-10 mb-3 inline text-co-gray-500 md:block">
          短期間でPython・機械学習が学べるプログラム。
        </p>
        <p class="co-display-10 mb-0 inline text-co-gray-500 md:block">
          機械学習プログラムを開発することがゴールです。
        </p>
      </template>
    </TeCourseAbout>
    <TeCoursePythonTarget />
    <TeCommonDemographics />
    <TeCoursePythonOutput />
    <TeCoursePythonCurriculum />

    <!-- 251202導線削除 -->
    <!-- <TeCommonBannerFreeTrial
      id="cta-first"
    /> -->

    <!-- 挫折させないパーソナルメンターサポート -->
    <section
      id="mentor-support"
      class="co-bg-striped"
    >
      <div class="co-container-lg px-4 pt-20">
        <h2 class="co-heading-2-caption">
          挫折させない<span class="block md:inline">パーソナルメンターサポート</span>
        </h2>
        <h3 class="co-display-12 mb-[3.25rem] text-left leading-base text-co-gray-600 md:text-center">
          学習時の「わからない」「続かない」を解消し、挫折をなくします。
          <br class="hidden md:block">
          実務で培った技術とノウハウで受講生一人ひとりをサポートします。
        </h3>
        <div class="flex flex-col justify-center gap-x-8 sm:px-36 lg:flex-row lg:px-0">
          <TeCommonMentorSupportMentoring />

          <TeCommonMentorSupportChatSupport>
            <template #title>
              毎日15時〜23時の
            </template>
            <template #lead>
              メンターが毎日8時間常時オンラインで待機してるので疑問点を聞けばチャットですぐに回答がもらえます。
            </template>
          </TeCommonMentorSupportChatSupport>

          <TeCommonMentorSupportIssueReview />
        </div>
      </div>
      <TeCommonMentorSupportAboutFlow>
        <template #flowOriginalText>
          ビットコインの価格変動を予測
        </template>
        <template #originalTitle>
          最終課題まで徹底サポート
        </template>
        <template #originalLead>
          受講目的や習得スキルに合わせて、乳がんの腫瘍を良性か悪性かを予測するプログラムまで徹底サポートします。
        </template>
      </TeCommonMentorSupportAboutFlow>

      <TeCommonMentorSupportMentor>
        <template #mentorImage1>
          <img
            class="size-full object-cover"
            src="~/assets/images/Te/TeCommon/MentorSupport/Mentor/mentor-ota.jpg"
            alt="Kazuki Ota"
            width="213"
            height="213"
            loading="lazy"
          >
        </template>
        <template #mentorName1>
          Kazuki
          <br>
          Ota
        </template>
        <template #mentorProfile1>
          システムエンジニア歴約20年、プログラミング歴約35年。プログラミングの守備範囲は、フロントエンド、サーバサイド、Android開発と広く、また、普段はシステム開発プロジェクトの管理や後輩の指導を行っています。
        </template>
        <template #mentorMessage1>
          プログラミングが出来るようになると世界が広がります！受講生様に寄り添い、楽しく学んで頂けるようサポートさせて頂きます。
        </template>
        <template #mentorImage2>
          <img
            class="size-full object-cover"
            src="~/assets/images/Te/TeCommon/MentorSupport/Mentor/mentor-saitoh.jpg"
            alt="Hitoshi Saitoh"
            width="213"
            height="213"
            loading="lazy"
          >
        </template>
        <template #mentorName2>
          Hitoshi
          <br>
          Saitoh
        </template>
        <template #mentorProfile2>
          国立研究開発法人の研究員として業務に従事。データサイエンティストとして、患者様の遺伝子配列データを用いた解析に日々邁進しております。技術の移り変わりに遅れを取らないよう、情報のアップデートが欠かせませんが、やりがいをもって取り組んでいます。
        </template>
        <template #mentorMessage2>
          プログラミングの学習は独学で行い、業務を通じて数多くの挑戦と挫折を経験しました。その経験を活かし、皆様が学習に取り組む際に寄り添い、心強いサポートを提供できればと考えております。一緒に成長していけることを心より楽しみにしております。
        </template>
      </TeCommonMentorSupportMentor>

      <TeCommonMentorSupportReason />
    </section>

    <TeCommonLearningCycle>
      <template #catchTwo>
        <span>機械学習プログラムを</span>
        <span class="text-co-primary-500">開発する</span>
      </template>
    </TeCommonLearningCycle>

    <TeCommonSliderVoice />

    <!-- 251202導線削除 -->
    <!-- <TeCommonBannerFreeTrial
      id="cta-second"
    /> -->

    <TeCommonCampaign
      :course-name-path="courseNamePath"
      :current-promotion="currentPromotion"
    />

    <section
      id="price"
      class="co-bg-striped"
    >
      <!-- 無料相談割引コード -->
      <TeCommonBannerTimeLimitCpnCode
        v-if="BannerNameForShowing === 'campaign'"
        :entry-campaign="entryCampaign"
      />

      <div class="co-container-lg px-4 py-20 xl:px-0">
        <h2 class="co-display-7 mb-[3.25rem] text-center">
          料金
        </h2>

        <TeCommonPriceTimeLimit
          v-if="BannerNameForShowing === 'discount'"
          :entry-discount-time-limit="entryDiscountTimeLimit"
        />

        <TeCoursePriceTable
          :course="course"
          :latest-cohort="latestCohort"
          :current-promotion="currentPromotion"
          :student="true"
          :mentoring="true"
          :chat-support="true"
          :badge-sakiwari-and-campaign="true"
        />

        <TeCoursePriceGreatPlan :course="course" />

        <TeCoursePriceInstallments :course="course" />

        <!-- 早めの申し込み・入金がお得！バナー -->
        <TeCommonPricePreviously />

        <!-- 参加条件 -->
        <TeCommonPriceParticipationconditions />

        <div class="flex flex-col items-center lg:flex-row lg:items-start lg:gap-x-8">
          <!-- 注意事項 -->
          <TeCommonPricePrecautions />
          <!-- キャンセルポリシー -->
          <TeCommonPriceCancelPolicy />
        </div>
      </div>
    </section>

    <TeCourseSakiwari
      :latest-cohort="latestCohort"
      :sakiwari-cohorts="sakiwariCohorts"
    >
      <template #annotation02>
        <li>※4週間・8週間プランは先割の対象外です。</li>
      </template>
    </TeCourseSakiwari>
    <TeCommonTomowari
      bg="#3e7baf"
      title-bg="#316189"
    />

    <!-- キャリアアップ支援事業 -->
    <TeCommonCareerUp
      :course="course"
      :course16weeks="true"
    />

    <TeCoursePythonSetBanner :course="course" />

    <!-- 251202導線削除 -->
    <!-- <TeCommonBannerFreeTrial
      id="cta-third"
    /> -->

    <TeCommonCareerSupport />

    <TeCommonComparisonSchool :benefits="true" />

    <TeCourseMessage />
    <TeCoursePythonFlow />
    <!-- 251202導線削除 -->
    <!-- <TeCoursePythonFaQ /> -->

    <!-- 無料相談割引コード -->
    <TeCommonBannerTimeLimitCpnCode
      v-if="BannerNameForShowing === 'campaign'"
      :entry-campaign="entryCampaign"
    />

    <TeCourseApply
      :course="course"
      :cohorts="cohorts"
      :latest-cohort="latestCohort"
      :sakiwari-cohorts="sakiwariCohorts"
      :current-promotion="currentPromotion"
      :course-name-path="courseNamePath"
      :entry-discount-time-limit="entryDiscountTimeLimit"
      :entry-campaign="entryCampaign"
    />

    <!-- 下部固定ボタン -->
    <!-- 251202導線削除 -->
    <!-- <TeCommonButtonFixedBottom /> -->
  </div>
</template>

<script lang="ts">
import { metaTags } from '~/utility/constants/metaTags'
import { IndexServices } from '~/services/indexService'
import { scriptTag } from '~/utility/scriptTag'
import { getCohorts, getCurrentPromotion, getCourse } from '~/utility/fetchAPI'
import { getAdItem } from '~/utility/utility'

import TeCoursePythonCover from '~/components/Te/TeCourse/Python/TeCoursePythonCover.vue'
import TeCommonPagenav from '~/components/Te/TeCommon/Pagenav/TeCommonPagenav.vue'
import TeCommonBannerTimeLimitCpnCode from '~/components/Te/TeCommon/Banner/TeCommonBannerTimeLimitCpnCode/TeCommonBannerTimeLimitCpnCode.vue'
import TeCommonBannerSettlement from '~/components/Te/TeCommon/Banner/TeCommonBannerSettlement/TeCommonBannerSettlement.vue'
import TeCommonBannerTimelimit from '~/components/Te/TeCommon/Banner/TeCommonBannerTimelimit/TeCommonBannerTimelimit.vue'
import TeCommonBannerCampaign from '~/components/Te/TeCommon/Banner/TeCommonBannerCampaign/TeCommonBannerCampaign.vue'
import TeCourseAbout from '~/components/Te/TeCourse/TeCourseAbout.vue'
import TeCoursePythonTarget from '~/components/Te/TeCourse/Python/TeCoursePythonTarget.vue'
import TeCommonDemographics from '~/components/Te/TeCommon/TeCommonDemographics/TeCommonDemographics.vue'
import TeCoursePythonOutput from '~/components/Te/TeCourse/Python/TeCoursePythonOutput.vue'
import TeCoursePythonCurriculum from '~/components/Te/TeCourse/Python/TeCoursePythonCurriculum.vue'
import TeCommonBannerFreeTrial from '~/components/Te/TeCommon/Banner/TeCommonBannerFreeTrial/TeCommonBannerFreeTrial.vue'
import TeCommonMentorSupportMentoring from '~/components/Te/TeCommon/MentorSupport/TeCommonMentorSupportMentoring/TeCommonMentorSupportMentoring.vue'
import TeCommonMentorSupportChatSupport from '~/components/Te/TeCommon/MentorSupport/TeCommonMentorSupportChatSupport/TeCommonMentorSupportChatSupport.vue'
import TeCommonMentorSupportIssueReview from '~/components/Te/TeCommon/MentorSupport/TeCommonMentorSupportIssueReview/TeCommonMentorSupportIssueReview.vue'
import TeCommonMentorSupportAboutFlow from '~/components/Te/TeCommon/MentorSupport/TeCommonMentorSupportAboutFlow/TeCommonMentorSupportAboutFlow.vue'
import TeCommonMentorSupportMentor from '~/components/Te/TeCommon/MentorSupportMentor/TeCommonMentorSupportMentor.vue'
import TeCommonMentorSupportReason from '~/components/Te/TeCommon/MentorSupport/TeCommonMentorSupportReason/TeCommonMentorSupportReason.vue'
import TeCommonLearningCycle from '~/components/Te/TeCommon/TeCommonLearningCycle/TeCommonLearningCycle.vue'
import TeCommonSliderVoice from '~/components/Te/TeCommon/Slider/TeCommonSliderVoice/TeCommonSliderVoice.vue'
import TeCommonCampaign from '~/components/Te/TeCommon/TeCommonCampaign/TeCommonCampaign.vue'
import TeCommonPriceTimeLimit from '~/components/Te/TeCommon/Price/TeCommonPriceTimeLimit/TeCommonPriceTimeLimit.vue'
import TeCoursePriceTable from '~/components/Te/TeCourse/TeCoursePriceTable.vue'
import TeCoursePriceGreatPlan from '~/components/Te/TeCourse/TeCoursePriceGreatPlan.vue'
import TeCoursePriceInstallments from '~/components/Te/TeCourse/TeCoursePriceInstallments.vue'
import TeCommonPricePreviously from '~/components/Te/TeCommon/Price/TeCommonPricePreviously/TeCommonPricePreviously.vue'
import TeCommonPriceParticipationconditions from '~/components/Te/TeCommon/Price/TeCommonPriceParticipationconditions/TeCommonPriceParticipationconditions.vue'
import TeCommonPricePrecautions from '~/components/Te/TeCommon/Price/TeCommonPricePrecautions/TeCommonPricePrecautions.vue'
import TeCommonPriceCancelPolicy from '~/components/Te/TeCommon/Price/TeCommonPriceCancelPolicy/TeCommonPriceCancelPolicy.vue'
import TeCourseSakiwari from '~/components/Te/TeCourse/TeCourseSakiwari.vue'
import TeCommonTomowari from '~/components/Te/TeCommon/Tomowari/TeCommonTomowari.vue'
import TeCommonCareerUp from '~/components/Te/TeCommon/CareerUp/TeCommonCareerUp.vue'
import TeCoursePythonSetBanner from '~/components/Te/TeCourse/Python/TeCoursePythonSetBanner.vue'
import TeCommonCareerSupport from '~/components/Te/TeCommon/TeCommonCareerSupport/TeCommonCareerSupport.vue'
import TeCommonComparisonSchool from '~/components/Te/TeCommon/Comparison/TeCommonComparisonSchool/TeCommonComparisonSchool.vue'
import TeCourseMessage from '~/components/Te/TeCourse/TeCourseMessage.vue'
import TeCoursePythonFlow from '~/components/Te/TeCourse/Python/TeCoursePythonFlow.vue'
import TeCoursePythonFaQ from '~/components/Te/TeCourse/Python/TeCoursePythonFaQ.vue'
import TeCourseApply from '~/components/Te/TeCourse/TeCourseApply.vue'
import TeCommonButtonFixedBottom from '~/components/Te/TeCommon/Button/TeCommonButtonFixedBottom/TeCommonButtonFixedBottom.vue'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faPython } from '@awesome.me/kit-65d95819ce/icons/classic/brands'

const options = {
  async setup() {
    const route = useRoute()
    const courseNamePath = route.path.split('/')[2]
    const course = ref<Object | null>(null)

    return {
      route,
      course,
      courseNamePath,
      faPython,
    }
  },
  oldHead() {
    const scriptTags = scriptTag({
      facebookPixelCode: true,
      criteoScript: true,
      criteoItem: {
        deviceSize: useNuxtApp().$deviceSize,
        item: this.course?.id,
      },
      remarketingTag: {
        ad_item_id: this.course?.id,
        ad_item_price: this.course ? getAdItem(this.course) : null,
      },
    })
    return {
      title: 'Pythonを学習・勉強できる講座/受講者数No.1 |テックアカデミー',
      meta: [
        ...metaTags(
          {
            description:
              '【テックアカデミー(TechAcademy)】選抜された現役エンジニアから学べるPythonの講座。受講者数No.1のオンラインプログラミングスクール。専属のパーソナルメンターがマンツーマンでサポート。転職サポートもあり。',
            twitterTitle: 'Pythonコース',
            twitterDescription:
              'Pythonを選抜された現役エンジニアから自宅で学べる。パーソナルメンターがマンツーマンで学習サポート。',
            twitterImage: '/_nuxt/ogp/te/tecourse/og-image-python.jpg',
            ogTitle: 'Pythonコース',
            ogDescription:
              'Pythonを選抜された現役エンジニアから自宅で学べる。パーソナルメンターがマンツーマンで学習サポート。',
            ogUrl: '/course/python',
            ogImage: '/_nuxt/ogp/te/tecourse/og-image-python.jpg',
          },
          process.env.host as string
        ),
      ],
      script: scriptTags.script,
      noscript: scriptTags.noscript,
    }
  },
  data() {
    return {
      cohorts: [],
      latestCohort: null,
      sakiwariCohorts: [],
      currentPromotion: null,
      screenName: '',
      entryDiscountTimeLimit: null,
      entrySettlementTimeLimit: null,
      entryPaymentUrl: null,
      entryCampaign: null,
    }
  },
  async mounted() {
    const {
      data: {
        entryDiscountTimeLimit,
        entrySettlementTimeLimit,
        entryPaymentUrl,
        entryCampaign,
      },
    } = await new IndexServices(this.$api).getTopTimeLimits()
    this.entryDiscountTimeLimit = entryDiscountTimeLimit
    this.entrySettlementTimeLimit = entrySettlementTimeLimit
    this.entryPaymentUrl = entryPaymentUrl
    this.entryCampaign = entryCampaign

    const queryConfig = {
      course_screen_name: this.courseNamePath,
      normal_opened: true,
    }
    getCohorts(this.$api, queryConfig).then((response) => {
      this.cohorts = response.data
      this.latestCohort = response.data[0]
    })
    getCohorts(this.$api, {
      course_screen_name: this.courseNamePath,
      sakiwari: true,
    }).then((response) => {
      this.sakiwariCohorts = response.data
    })
    getCurrentPromotion(this.$api).then((response) => {
      this.currentPromotion = response.data
    })
    this.course = (
      await getCourse(this.$api, this.courseNamePath, { include_pack: true })
    )?.data
  },
  computed: {
    BannerNameForShowing() {
      if (this.entrySettlementTimeLimit) {
        return 'settlement'
      } else if (this.entryCampaign) {
        return 'campaign'
      } else if (this.entryDiscountTimeLimit) {
        return 'discount'
      } else {
        return null
      }
    },
    beginsAt() {
      return this.latestCohort
        ? new Date(this.latestCohort.attributes.begins_at)
        : null
    },
    closesAt() {
      return this.latestCohort
        ? new Date(this.latestCohort.attributes.closes_at)
        : null
    },
  },
  methods: {},
  components: {
    TeCoursePythonCover,
    TeCommonPagenav,
    TeCommonBannerTimeLimitCpnCode,
    TeCommonBannerSettlement,
    TeCommonBannerTimelimit,
    TeCommonBannerCampaign,
    TeCourseAbout,
    TeCoursePythonTarget,
    TeCommonDemographics,
    TeCoursePythonOutput,
    TeCoursePythonCurriculum,
    TeCommonBannerFreeTrial,
    TeCommonMentorSupportMentoring,
    TeCommonMentorSupportChatSupport,
    TeCommonMentorSupportIssueReview,
    TeCommonMentorSupportAboutFlow,
    TeCommonMentorSupportMentor,
    TeCommonMentorSupportReason,
    TeCommonLearningCycle,
    TeCommonSliderVoice,
    TeCommonCampaign,
    TeCommonPriceTimeLimit,
    TeCoursePriceTable,
    TeCoursePriceGreatPlan,
    TeCoursePriceInstallments,
    TeCommonPricePreviously,
    TeCommonPriceParticipationconditions,
    TeCommonPricePrecautions,
    TeCommonPriceCancelPolicy,
    TeCourseSakiwari,
    TeCommonTomowari,
    TeCommonCareerUp,
    TeCoursePythonSetBanner,
    TeCommonCareerSupport,
    TeCommonComparisonSchool,
    TeCourseMessage,
    TeCoursePythonFlow,
    TeCoursePythonFaQ,
    TeCourseApply,
    TeCommonButtonFixedBottom,
    FontAwesomeIcon,
  },
}

export default defineNuxtComponent(options)
</script>
